<template>
  <sfs-form-modal
    :id="modalId"
    size="sm"
    title="Add a Commission Plan"
    @on-hide="resetFormData"
  >
    <commission-plans-form
      :organization="organization"
      :organization_id="organization_id"
      @on-submit="createCommissionPlan"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import CommissionPlansForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CommissionPlansAddModal',
  mixins: [formModalMixin],
  components: {
    CommissionPlansForm,
  },
  data() {
    return {
      modalId: 'commission-plans-add-modal',
    };
  },
  methods: {
    createCommissionPlan(data, handleCreate) {
      const ratesByYear = {};
      data.rates_by_year.forEach((yearlyRate, index) => {
        ratesByYear[index + 1] = yearlyRate.rate;
      });
      handleCreate(this.$commissionPlansAPI.create({ ...data, rates_by_year: ratesByYear }));
    },
    onSave() {
      this.closeModal();
      this.resetFormData();
      this.$emit('on-save');
    },
  },
  computed: {
    organization() {
      return this.$store.getters.currentOrganization;
    },
    organization_id() {
      return this.organization?.id;
    },
  },
};
</script>
